import { ICrumb } from '../../src/components/BreadCrumbs'
import PageTitle from '../../src/components/PageTitle'
import { PageDocument, PageTitleSlice } from '../../prismicio-types'

const PageTitleSlice = ({
	slice,
	context: { crumbs },
}: {
	slice: PageTitleSlice
	context: { page: PageDocument; crumbs: ICrumb[] }
}) => {
	return (
		<PageTitle
			heading={slice.primary.heading ?? ''}
			subtitle={slice.primary.subtitle ?? ''}
			show_breadcrumbs={slice.primary.show_breadcrumbs}
			background_color={slice.primary.background_color ?? 'Blue (100)'}
			crumbs={crumbs}
			center_alignment={slice.primary.center_alignment}
			repeatableItems={slice.items}
		/>
	)
}

export default PageTitleSlice
